export const myReviewsFiltersName = {
  countryFilter: 'countryFilter',
  brandFilter: 'brandFilter',
  producerFilter: 'producerFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  wineRegionEUFilter: 'wineRegionEUFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineColourFilter: 'wineColourFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  grapesFilter: 'grapesFilter',
  additionalInfoFilter: 'additionalInfoFilter',
  wwlRatingFilter: 'wwlRatingFilter',
  monocepageFilter: 'monocepageFilter',
  samplingDateFilter: 'samplingDateFilter',
  createdAtFilter: 'createdAtFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  drinkingWindowFilter: 'drinkingWindowFilter',
  usersFilter: 'usersFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
  specialClassificationFilter: 'specialClassificationFilter',
  euGITypeFilter: 'euGITypeFilter',
  venueTypeFilter: 'venueTypeFilter',
  recognitionStatusFilter: 'recognitionStatusFilter',
  statusFilter: 'statusFilter',
}
export const myReviewsFiltersTitle = {
  countryFilter: 'filters.names.countryFilter',
  brandFilter: 'filters.names.brandFilter',
  producerFilter: 'filters.names.producer',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  wineRegionEUFilter: 'filters.names.wineRegionEUFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  grapesFilter: 'filters.names.grapesFilter',
  monocepageFilter: 'filters.names.monocepageFilter',
  additionalInfoFilter: 'filters.names.certificatesFilter',
  wwlRatingFilter: 'filters.names.wwlRatingFilter',
  samplingDateFilter: 'filters.names.samplingDateFilter',
  privateReviewFilter: 'filters.names.privateReviewFilter',
  createdAtFilter: 'filters.names.createdAtFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  drinkingWindowFilter: 'filters.names.drinkingWindowFilter',
  usersFilter: 'filters.names.reviewer',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
  euGITypeFilter: 'filters.names.euGITypeFilter',
  venueTypeFilter: 'filters.names.venueTypeFilter',
  recognitionStatusFilter: 'filters.names.recognitionStatusFilter',
  statusFilter: 'filters.names.statusFilter',
}
export const myReviewsFiltersKey = () => {
  return {
    countryFilter: 'product.wine.country',
    brandFilter: 'product.wine.brand',
    producerFilter: 'product.wine.tradeName',
    nationalGITypeFilter: 'product.wine.nationalGIType',
    wineRegionEUFilter: 'product.wine.wineRegionEU',
    geoIndicationFilter: 'product.wine.geoIndication',
    wineTypeFilter: 'product.wine.wineType',
    wineColourFilter: 'product.wine.wineColor',
    sweetnessTypeFilter: 'product.wine.sweetnessLevel',
    vintageFilter: 'product.wine.vintage',
    grapesFilter: 'grapeAndMonocepage',
    monocepageFilter: 'grapeAndMonocepage.monocepage',
    additionalInfoFilter: 'product.wine.certification',
    wwlRatingFilter: 'product.wine.rating',
    samplingDateFilter: 'date',
    createdAtFilter: 'createdAt',
    bottleSizeFilter: 'product.bottleSize',
    packageTypeFilter: 'packageType',
    drinkingWindowFilter: 'drinkingWindow',
    usersFilter: 'authorUsername',
    alcoholLevelFilter: 'product.alcoholOnLabel',
    specialClassificationFilter: 'product.wine.specialClassification',
    euGITypeFilter: 'product.wine.nationalGIType.euGIType',
    venueTypeFilter: 'placeType',
    recognitionStatusFilter: 'recognitionStatus',
    statusFilter: 'status',
  }
}
